import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerPlan extends AManagerApi {
    protected _url: string = '/owner/plan';
}
